/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// ✅ Add these manually for Safari 12 compatibility
import 'core-js/es/array';
import 'core-js/es/object';
import 'core-js/es/promise';
import 'core-js/es/string';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/symbol';
import 'core-js/es/function';

// Zone.js is already included with Angular
//import 'zone.js';  // Included with Angular CLI

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
